/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNewOrder } from '@/context/NewOrderContext';
import { firestore } from '@/lib/firebase/firebase';
import { OutlinedInput } from "__barrel_optimize__?names=OutlinedInput!=!@mui/material";
import { doc, updateDoc } from 'firebase/firestore';
import React from 'react';
function AdditionalNotes() {
    const { order, setOrder } = useNewOrder();
    const handleChange = (e)=>{
        setOrder((prev)=>({
                ...prev,
                additional_notes: e.target.value
            }));
        if (order.id) {
            const docRef = doc(firestore, 'orders', order.id);
            updateDoc(docRef, {
                additional_notes: e.target.value
            });
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-10 flex flex-col gap-5",
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx("span", {
                    className: "text-xl",
                    children: "Additional Notes:"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "bg-neutral-100 p-5 rounded-xl",
                children: /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(OutlinedInput, {
                        value: order === null || order === void 0 ? void 0 : order.additional_notes,
                        onChange: handleChange,
                        fullWidth: true,
                        name: "additional_notes",
                        multiline: true,
                        minRows: 5,
                        placeholder: "If you have anything else you think we should know, enter it here."
                    })
                })
            })
        ]
    });
}
export default AdditionalNotes;
